import React from 'react';
import { Provider } from 'react-redux';
import { store } from '../store';

const withRedux = (component: () => React.ReactNode) => () => <Provider store={store}>{component()}</Provider>;
export default withRedux;
